module.exports = __webpack_public_path__ + "img/banner2.2804236b.png";